const { hostname, protocol } = window.location;
const apiPath = '/api/';
const apiFullPath = process.env.NODE_ENV === 'development'
  ? `https://app-qa.sorted.com${apiPath}`
  : `${protocol}//${hostname}${apiPath}`;

// Add required codes handling if needed
const isResourceNotFound = (response) => response.status === 404;

const isRequestIncorrect = (response) => response.status === 400;

const isRequestSuccesful = (response) => response.status >= 200
  && response.status < 204;
class Http {
  static async get(url) {
    const response = await fetch(apiFullPath + url, { method: 'GET' });
    const notFound = isResourceNotFound(response);
    const success = isRequestSuccesful(response);
    const incorrectRequest = isRequestIncorrect(response);
    const data = success ? await response.json() : null;
    return {
      result: {
        success,
        notFound,
        incorrectRequest,
      },
      data,
    };
  }
}

export default Http;
